import {
  APP_EXPERTS_SEARCH_REQUEST,
  APP_EXPERTS_SEARCH_RESPONSE,
  APP_EXPERTS_SEARCH_FAILURE,
  APP_EXPERTS_SEARCH_FILTER_UPDATE,
  APP_EXPERTS_SEARCH_FULL_RESET,
  UPDATE_APP_STAKEHOLDER_FILTERS,
} from "../../../actions/types";
import locations from "../../../utils/isoCountryWithContinent";


const initialState = {
  multiSort: {},
  isInitialScreen: true,
  isFetching: false,
  results: [],
  error: false,
  activePage: 1,
  filters: {
    from: 0,
    size: 25,
    listType: "shortList",
    LAST_NAME: "",
    FIRST_NAME: "",
    SPECIALITY: "",
    ROLE: "",
    DEPARTMENT: "",
    CITY: "",
    REGION: "", 
    SPECIALITY_CENTRE: "",
    BLANKS: "",
    TIER: "",
    RISING_STAR: "",
    ACTIVITY_STATUS: "",
    RELEVANCE_HIGH: "",
    RELEVANCE_MEDIUM: "",
    RELEVANCE_LOW: "",
    CLINICAL_TRIAL: "",
    PRINCIPAL_INVESTIGATOR: "",
    ARTICLE_COUNT: "",
    CITATION_COUNT: "",
    CONGRESS_PRESENCE: "",
    "PAG/MEDICAL_BODIES_MEMBERSHIP": "",
    GUIDELINES: "",
    REGULATORY: "",
    ACCESS: "",
    TOTAL_ARTICLES: "",
    TOTAL_CITATION_COUNT: "",
    "H-INDEX": "",
    sorting: { key: "TOPIC_CITATION_COUNT", order: "desc" },
    queryText: "",
    experts: "",
    affs: [],
    location: [],
    LABEL: [],
    CLINICIAN: "",
    RELEVANCE: "",
    AFFILIATION_TYPE: ""
  },
  keyword: "",
  total: 0,
  isSaveActive: false,
  selectedItems: {},
  saveListType: "",
  totalArticles: 0,
  totalTrials: 0,
  advExperts: 0,
  total5YExperts: 0,
  totalCountries: 0,
};

const setRequest = (state, action) => {
  let { keyword, filters, activePage } = action.payload;
  if (!filters) {
    filters = {
      year: "",
      location: [],
      partner: "false",
    };
  }

  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    results: [],
    keyword: keyword,
    filters: { ...filters, activePage },
    totalArticles: 0,
    total: 0,
    totalTrials: 0,
    advExperts: 0,
    total5YExperts: 0,
    totalCountries: 0,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    results: [],
  };
};


export const getOptions = (results, key, nameMapping, payload) => {
  let accesskey = nameMapping[key] || key;
  let options = [];

  if(payload[`${accesskey}Options`]){
    return {
      [`${key}Options`]: payload[`${accesskey}Options`]
    }
  }

  
  if(key === 'location'){
     options = locations.map(l => l.toUpperCase());
  } else {
    results.forEach(l => {
      if(l[accesskey]){
        if(Array.isArray(l[accesskey])){
          options = [...options, ...l[accesskey]];
        } else{ 
          options.push(l[accesskey]);
        }
        
      }
   });
   options = [...new Set([...options])];
  }
  

 return {
  [`${key}Options`]: options,
 }
}

const setResponse = (state, action) => {
  let {
    results = [],
    totalArticles,
    total,
    totalCountries,
    totalTrials,
    advExperts,
    total5YExperts,
    excludeColumns = [],
    
  } = action.payload;
  let filters = state.filters || {};
  let nameMapping = {
    'affs': 'AFFILIATION',
    'experts': 'FULL_NAME'
  };
  let optionsKeys = ['SPECIALITY', 'DEPARTMENT', 'location', 'cois', 'affs', 'experts', 'cois',"LABEL", 'ACTIVITY_STATUS', 'CLINICIAN', 'RELEVANCE', 'STATE', 'AFFILIATION_TYPE'];
  optionsKeys.forEach(l => {
    let optionsInfo = getOptions(results, l, nameMapping, action.payload);
    filters = {
      ...filters,
      ...optionsInfo,
      CLINICIANOptions: ['-','CLINICIAN',  'OTHER_HCP', "RESEARCHER"],
      RELEVANCEOptions: ["High", 'Medium', 'Low']
    }    
  });

  return {
    ...state,
    isFetching: false,
    error: false,
    results: results,
    isInitialScreen: false,
    totalArticles,
    total,
    total5YExperts,
    advExperts,
    totalCountries,
    totalTrials,
    excludeColumns,
    filters
  };
};

const updateFilterState = (state, action) => {
  let { filters } = action.payload;
  return {
    ...state,
    filters,
  };
};

const toggleFullReset = (state, action) => {
  const { moduleId } = action.payload;
  let filters = initialState.filters;
  if (moduleId === "DS" || moduleId === "LGS" || moduleId === "MPS") {
    filters = {
      ...filters,
      sorting: { key: "RELEVANCE", order: "desc" },
    };
  }

  if (moduleId === "PAH") {
    filters = {
      ...filters,
      sorting: { key: "affs", order: "asc" },
      location: [
        {
          label: "EU5",
          value: "EU5",
        },
      ],
    };
  }

  if (moduleId === "HYPERTROPHIC_CARDIOMYOPATHY" || moduleId === "HFR") {
    filters = {
      ...filters,
      sorting: { key: "CITATION_COUNT", order: "desc" },
    };
  }

  if (moduleId === "PAEDIATRIC_CARDIOLOGY") {
    filters = {
      ...filters,
      // sorting: { key: "AFFILIATION", order: "asc" },
      location: [
        {
          label: "Germany",
          value: "Germany",
        },
        {
          label: "United Kingdom",
          value: "United Kingdom",
        },
      ],
    };
  }


  return {
    ...state,
    filters: { ...filters, listType: state.filters.listType || 'shortList' },
    activePage: initialState.activePage,
  };
};

const mergeAffiliationFilters = (state, action) => {
  const { filters } = action.payload;
  const { affName, country, queryText } = filters || {};
  
  const newFilters = { affs: [{
    label: affName,
    value: affName
  }], location: country, queryText };
  return {
    ...initialState,
    filters: { ...initialState.filters, ...newFilters },
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_EXPERTS_SEARCH_RESPONSE:
      return setResponse(state, action);

    case APP_EXPERTS_SEARCH_FAILURE:
      return setFailure(state, action);

    case APP_EXPERTS_SEARCH_REQUEST:
      return setRequest(state, action);

    case APP_EXPERTS_SEARCH_FILTER_UPDATE:
      return updateFilterState(state, action);

    case APP_EXPERTS_SEARCH_FULL_RESET:
      return toggleFullReset(state, action);

    case UPDATE_APP_STAKEHOLDER_FILTERS:
      return mergeAffiliationFilters(state, action);

    default:
      return state;
  }
};
